import React from 'react'
import { FormControl, MenuItem } from '@material-ui/core'
import { StyledFormLabel, StyledSelect } from './style'

const ProjectSelection = ({
  projects,
  selectedProject,
  setSelectedProject,
  displayName,
  title = 'Select Project',
}) => {
  return (
    <FormControl>
      <StyledFormLabel id="project-selct-group-label">{title}</StyledFormLabel>
      <StyledSelect
        labelId="project-select-label"
        id="project-select"
        value={selectedProject}
        onChange={e => setSelectedProject(e.target.value)}
      >
        {projects.map(project => (
          <MenuItem key={project._id} value={project._id}>
            {displayName?.(project) || project.name}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  )
}

export default ProjectSelection
